import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ICardAcceptorIdField {
	changeCardAcceptorId: (value: string) => void;
}

const CardAcceptorIdField: React.FC<ICardAcceptorIdField> = ({ changeCardAcceptorId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterCardAcceptorId') }], [t]);

	return (
		<FormInput
			testId="CardAcceptorIdField"
			name="cardAcceptorId"
			label="cardAcceptorIdLabel"
			onChange={changeCardAcceptorId}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CardAcceptorIdField);
